<template>
  <div class="usable">
    <div class="productsList" v-if="couponUsableList.length">
      <ul class="listTypeCart">
        <li
          class="productItem"
          v-for="(coupon, index) in couponUsableList"
          :key="index"
        >
          <router-link
            :to="{
              name: 'couponView',
              params: { couponId: coupon.purchaseProductId }
            }"
          >
            <div class="productWrap">
              <div class="productDeco">
                <span class="productImg">
                  <img
                    :src="coupon.imageUrl"
                    width="100%"
                    height="100%"
                    alt=""
                  />
                </span>

                <span class="productName">{{ coupon.productName }}</span>
                <span class="productGame">{{ coupon.serviceName }}</span>
                <span class="productPeriod">
                  {{ convertDate(coupon.expireDate) }} {{ $t('coupon.until') }}
                  <strong v-if="isExpired(coupon.remainExpireDay) === false">
                    ({{ remainExpireDay(coupon.remainExpireDay) }})
                  </strong>
                </span>
                <span
                  class="productState"
                  :class="couponStatus(coupon).className"
                >
                  {{ couponStatus(coupon).result }}
                </span>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <contents-none v-else none-text="내 쿠폰이 없습니다."></contents-none>
  </div>
</template>

<script>
import ContentsNone from '@/views/base/ContentsNone'
import { mapActions, mapGetters } from 'vuex'
import mixin from '@/utils/mixin'

export default {
  mixins: [mixin],
  name: 'CouponUsable',
  components: {
    ContentsNone
  },
  watch: {
    bottom: {
      handler(n, o) {
        if (n) {
          this.getCouponUsableList()
        }
      }
    }
  },
  data() {
    return {
      bottom: false
    }
  },
  computed: {
    ...mapGetters('my', ['couponUsableList'])
  },
  methods: {
    ...mapActions('my', ['getCouponUsableList']),
    remainExpireDay(remainExpireDay) {
      let result = ''
      if (remainExpireDay >= 0) {
        if (remainExpireDay === 0) {
          result = this.$t('coupon.until_today')
        } else {
          result = `${remainExpireDay.addComma()}${this.$t(
            'coupon.days_remaining'
          )}`
        }
      }
      return result
    },
    isExpired(remainExpireDay) {
      return remainExpireDay < 0
    },
    couponStatus({ purchaseProductCouponStatus, couponPinStatus }) {
      let className = ''
      let result = ''
      if (purchaseProductCouponStatus === 100) {
        result = this.$t('coupon.purchase_completed')
        className = 'productStateViolet'
      } else if (
        purchaseProductCouponStatus === 150 &&
        couponPinStatus === 10
      ) {
        result = this.$t('coupon.usable')
        className = 'productStateGray'
      }
      return { result, className }
    },
    convertDate(date) {
      return date.replace('T', ' ')
    },
    handleScroll() {
      this.bottom = this.bottomVisible()
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.getCouponUsableList(true)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss"></style>
